'use client';

import { ToastProvider as CommonToastProvider } from '@common/components';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { Fragment, type ReactNode } from 'react';

import { findRoute } from '@/utils';

import { DONATION_BNB_TOAST_ITEMS } from '../donation/constants';

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider = ({ children }: ToastProviderProps) => {
  const pathname = usePathname();

  const currentRoute = findRoute(pathname);

  const isTopToast = currentRoute?.toastDirection === 'top';

  //* 특정 조건에서 스타일 주입 (top 토스트에서는 bottom 위치 불필요)
  const bottomClassName = (() => {
    if (isTopToast) return '';

    if (
      DONATION_BNB_TOAST_ITEMS.some(({ route }) => route.pathname === pathname)
    ) {
      return 'bottom-[calc(var(--toast-bottom-offset,60px)+var(--safe-area-bottom,0px))] mobile-sm:bottom-[calc(var(--toast-bottom-offset,60px)+16px+var(--safe-area-bottom,0px))]';
    }

    return 'bottom-[calc(var(--toast-bottom-offset,0px)+var(--safe-area-bottom,0px))] mobile-sm:bottom-[calc(var(--toast-bottom-offset,0px)+16px+var(--safe-area-bottom,0px))]';
  })();

  const result = [
    //* result.reverse 에 리랜더링 되지 않도록 하기 위해 Fragment 사용
    <Fragment key="toast-provider-children">{children}</Fragment>,
    <CommonToastProvider
      key="toast-provider"
      className={cn(
        'relative z-[60] w-full p-0',
        'mobile-tablet:!left-0 mobile-tablet:mx-auto mobile-tablet:max-w-[calc(100%-32px)] mobile-tablet:!translate-x-0',
        isTopToast ? 'top-16' : 'max-h-0',
        bottomClassName,
      )}
      position={isTopToast ? 'top-center' : 'bottom-center'}
    />,
  ];

  if (isTopToast) result.reverse();

  return result;
};
